const LocalEventDetails = [
  {
    id: 1,
    title: "Patri Sir Birthday Celebrations 2023 at APMA Center",
    img: require("./images/PatriSirBday.jpg"),
  },
  {
    id: 2,
    title: "Seth Wisdom Workshop by Bala Krishna Sir",
    img: require("./images/SethWS.jpg"),
  },
  {
    id: 3,
    title: "Crystal Kids Meditation - Certificate Program",
    img: require("./images/Crystal_KIDS_Meditation_crtf.jpg"),
  },
];

const USA_EventDetails = [
  {
    id: 1,
    title: "Mega Meditation Summit (Dhyanma Maha Chakram) @ Dallas",
    img: require("./images/MMS_Event.jpeg"),
  },
  {
    id: 2,
    title: "Pyramid Bhumi Pooja @ Raliegh",
    img: require("./images/RaleighFirstPyramidLayingStone.jpg"),
  },
  {
    id: 3,
    title: "Patriji Amruthosthav @ Maryland",
    img: require("./images/DMMS_Dallas.jpg"),
  },
];

export { LocalEventDetails, USA_EventDetails };
